import React from "react";
import HeaderStatic from "@pwa/Header/HeaderStatic";
import TabPartial from "./Partials/Tab";
import ContentPartial from "./Partials/Content";

const InsightMobile: React.FC<any> = ({ insightList }) => {
  return (
    <>
      <HeaderStatic title="MyTEnS Insight" backUrl={"/"} />
      <TabPartial />
      <ContentPartial insightList={insightList} />
    </>
  );
};

export default InsightMobile;
